import BackendService from '@/services/Backend'

class ResourcesService extends BackendService {
  constructor (baseUrl, interceptor) {
    super(baseUrl, '/', interceptor)
  }

  getContentByPath (path) {
    return this.get(path)
  }

  getContentLibrary ({ file, ...payload }) {
    return this.get(`content/sanitas-internet/content-library/${file}`, payload)
  }

  getNotificationMessages ({ serviceUri, ...payload }) {
    return this.get(serviceUri, payload, true)
  }
}

export default ResourcesService
